import { MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES } from 'app/constants/userRestrictions';
import { LANG_TITLE_BY_CODE } from 'app/lang/constants';

export const toFixed = (value: string | number, precise: number) => {
  return Number(`${Math.floor(Number(`${value}e+${precise}`))}e-${precise}`);
};

export const DEFAULT_OPTIONS = {
  decimals: MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES,
  decimalPoint: '.',
  thousandsSeparator: ' ',
  skipTruncate: true,
  useMathParse: true,
};

type DelimitersByLangType = Record<
  keyof typeof LANG_TITLE_BY_CODE,
  {
    thousands: string;
    decimal: string;
  }
>;

export const DELIMITERS_BY_LANG: DelimitersByLangType = {
  ru: {
    thousands: ' ',
    decimal: ',',
  },
  en: {
    thousands: ' ',
    decimal: '.',
  },
  uz: {
    thousands: ' ',
    decimal: ',',
  },
  kk: {
    thousands: ' ',
    decimal: ',',
  },
  ky: {
    thousands: ' ',
    decimal: ',',
  },
  tg: {
    thousands: ' ',
    decimal: ',',
  },
};
